import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { isSafari } from 'react-device-detect'
import Header from './Header/Header'
import '../../assets/scss/_app.scss'
import { AppContext } from '../utils/context'
import Sidebar from './Sidebar/Sidebar'
import Seo from './Seo/Seo'
import Footer from './Footer/Footer'
import MainBadges from './MainBadges/MainBadges'
import CookieBanner from './CookieBanner/CookieBanner'
import AlertProvider from '../components/common/Alert/AlertProvider'
import AlertNotification from '../components/common/Alert/AlertNotification'
import ScrollUpButton from '../components/common/ScrollUpBotton/ScrollUpButton'
import FormSection from '../components/reusable/Form/FormSection'
import HeaderBanner from './Header/HeaderBanner/HeaderBanner'
import useHeaderBannerQueryHook from '../hooks/query/useHeaderBannerQueryHook'
import * as styles from './Header/HeaderBanner/header-banner.module.scss'

const exclude = [
  '/contacts',
  '/contacts/',
  '/privacy-policy',
  '/privacy-policy/',
  '/cookie-policy/',
  '/cookie-policy',
]

function scrollBugFix(url) {
  const buggedPath = [
    '/blog/',
    '/blog',
    '/cookie-policy/',
    '/cookie-policy',
    '/contacts/',
    '/contacts',
  ]
  function isBuggedPath() {
    return buggedPath.some((item) => url.pathname.includes(item))
  }
  if (isBuggedPath()) {
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 100)
  }
}

const MainLayout = ({ children, location, seoData, wrapClass }) => {
  const bannerData = useHeaderBannerQueryHook()
  const [sidebarState, setSidebarState] = useState(false)
  const [modalState, setModalState] = useState(false)
  const [blockScroll, setBlockScroll] = useState('')
  const [badgesState, setBadgesState] = useState(false)
  const [showForm, setShowForm] = useState(true)
  const [headerBannerActive, setHeaderBannerActive] = useState(!!bannerData)

  const sidebarToggle = (value) => {
    setSidebarState(value)
  }

  useEffect(() => {
    if (typeof window !== 'undefined' && isSafari) {
      scrollBugFix(location)
    }

    setBadgesState(location.pathname === '/')
    const isFormVisible =
      exclude.includes(location.pathname) || location.pathname.includes('/blog')

    setShowForm(!isFormVisible)
  }, [location])

  useEffect(() => {
    setBlockScroll(modalState ? 'sidebar-open' : '')
  }, [modalState])

  return (
    <div className={wrapClass}>
      {seoData && (
        <Seo seoData={seoData} bodyClass={blockScroll} location={location} />
      )}
      <AlertProvider>
        <AlertNotification />
        <AppContext.Provider value={[modalState, setModalState]}>
          {headerBannerActive && <div className={styles.bannerBlock} />}
          {headerBannerActive && <HeaderBanner bannerData={bannerData} />}
          <Header
            isBannerActive={headerBannerActive}
            location={location}
            sidebarToggle={sidebarToggle}
          />
          <Sidebar sidebarState={sidebarState} sidebarToggle={sidebarToggle} />
          <main id="main-block">{children}</main>
          {showForm && <FormSection />}
          {badgesState && <MainBadges title="" description="" />}
          <Footer />
          <CookieBanner />
          <ScrollUpButton />
        </AppContext.Provider>
      </AlertProvider>
    </div>
  )
}

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.shape({ pathname: PropTypes.string }),
  seoData: PropTypes.shape({
    seoDescription: PropTypes.string,
  }).isRequired,
}
MainLayout.defaultProps = {
  location: {
    pathname: '',
  },
}
export default MainLayout
